var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const VALID_IMAGE_FORMATS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']);
/**
 * Default Amplience Dynamic media API parameters:
 * https://amplience.com/docs/dynamicmedia/dmapireference.html
 */
const defaultParams = {
    fmt: 'auto',
    qlt: 'default',
    // 'fmt.jp2.qlt': 60, // This is incorrectly formatted, business don't require this prop
    //bg: 'rgb(255, 255, 255)', // We don't set a default background color as it can cause issues with transparent images - let them render with transparent background instead of unexpected white bg. This can be overridden by passing a bg param to processImageUrl if needed.
    // 'fmt.jpeg.interlaced': true,
};
/**
 * Extracts the image extension from pathname if it exists
 * Returns empty string if no extension (lets Amplience auto-detect via fmt: auto)
 */
const getImageExtension = (pathname) => {
    var _a;
    const parts = pathname.split('.');
    if (parts.length > 1) {
        const ext = (_a = parts.at(-1)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (ext && VALID_IMAGE_FORMATS.has(ext)) {
            return '.' + ext;
        }
    }
    // No valid extension found - let Amplience handle via fmt: auto
    return '';
};
/**
 * Processes image URLs and preserves original formats (PNG, JPG, etc)
 * If no extension, relies on fmt: auto parameter for Amplience auto-detection
 * Adds/replaces params in the query string and appends templates
 */
export const processImageUrl = (urlString, params, templates, isConfigProgressImage) => {
    try {
        const url = new URL(urlString);
        // Only apply default params if not set on the URL already
        Object.keys(defaultParams).forEach((key) => !url.searchParams.has(key) && url.searchParams.set(key, '' + defaultParams[key]));
        // Apply all params passed in
        params && Object.keys(params).forEach((key) => url.searchParams.set(key, '' + params[key]));
        if (isConfigProgressImage) {
            url.searchParams.set('fmt.jpeg.interlaced', 'true');
        }
        const paramString = url.searchParams.toString();
        const templateString = (templates === null || templates === void 0 ? void 0 : templates.join('&')) || '';
        const query = templateString || paramString
            ? '?' + templateString + (templateString && paramString ? '&' : '') + paramString
            : '';
        // Extract extension before removing it from pathname
        const imageExt = getImageExtension(url.pathname);
        const pathname = url.pathname.split('.')[0];
        return url.origin + pathname + imageExt + query;
    }
    catch (e) {
        // Invalid URL format
        return '';
    }
};
export const checkImageExists = (imgUrl) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const loadImg = new Image();
        loadImg.src = imgUrl;
        loadImg.onload = () => setTimeout(() => {
            resolve(imgUrl);
        }, 50);
        loadImg.onerror = () => reject(new Error(`Image failed to load: ${imgUrl}`));
    });
});
export const getBreakpoints = (squareImage, fullWidthImage, theme) => {
    const breakpoints = [
        { breakpoint: 'xs', query: 'max-width', w: theme.breakpoints.values.xs, aspect: '1:1' },
        {
            breakpoint: 'sm',
            query: 'max-width',
            w: theme.breakpoints.values.sm,
            aspect: squareImage ? '1:1' : '2:1',
        },
        {
            breakpoint: 'md',
            query: 'max-width',
            w: fullWidthImage ? theme.breakpoints.values.md : theme.breakpoints.values.md / 2,
            aspect: fullWidthImage ? '2:1' : '1:1',
        },
        {
            breakpoint: 'lg',
            query: 'max-width',
            w: fullWidthImage ? theme.breakpoints.values.lg : theme.breakpoints.values.lg / 2,
            aspect: fullWidthImage ? '2:1' : '1:1',
        },
    ];
    return breakpoints;
};
export const getAspectRatio = (squareImage) => {
    if (squareImage) {
        return '1:1';
    }
    return '2:1';
};
export const getDarknessAttribute = (darknessLevel) => {
    return typeof darknessLevel === 'number'
        ? { cm: 'dark', bg: `rgba(0,0,0, ${Math.round((100 - darknessLevel) * 2.55)})` }
        : {};
};
